<template>
  <v-app>
  <v-container fluid fill-height>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 sm4 md4>
      <v-flex>
        <v-card-actions style="margin-bottom: -20px;">  
          <v-spacer></v-spacer>
            <v-avatar
                  color="grey lighten-4"
            >
                <img style="height: 10%; width: 220px;" src="@/assets/horizontalLogo.png" alt="avatar">
              </v-avatar>
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-actions style="margin-top: -20px;">
              <v-spacer></v-spacer>  
                <h3 class="primary--text font-weight-light text-muted">  All in One Business Platform </h3>
              <v-spacer></v-spacer>
            </v-card-actions>
      </v-flex>  
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Create an Account
        </v-card-title>
        <v-form v-model="isValid">
        <v-card-text>
           <v-layout row wrap >
             <v-flex xs12 sm12 md12>
              <v-text-field 
                prepend-icon="account_balance"
                name="brand"
                label="Brand"
                id="brand"
                type="text"
                v-model="brand"
                :counter="50"
                :rules="nameRules"
                required></v-text-field>
              <v-text-field
                prepend-icon="person"
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model="email"
                :rules="emailRules"
                required></v-text-field>
              <v-text-field
                prepend-icon="lock"
                name="password"
                label="Password"
                id="password"
                type="password"
                v-model="password"
                :rules="passwordRules"
                required></v-text-field>
              <v-text-field
                prepend-icon="lock"
                name="confirmPassword"
                label="Confirm Password"
                id="confirmPassword"
                type="password"
                v-model="rePassword"
                :rules="passwordRules"
                required
              ></v-text-field>
              
              <!-- <v-select
                prepend-icon="attach_money"
                v-model="financialYear.value"
                :items="gFinancialYear"
                label="Financial Year"
                required
              ></v-select> -->
              
              <!-- <v-select
                prepend-icon="attach_money" 
                v-model="identityType.value" 
                :items="gIdentityType" 
                clearable 
                label="Identity Type">
              </v-select> -->

              <!-- <v-select
                prepend-icon="confirmation_number" 
                v-model="casteType.value" 
                :items="gCasteType" 
                clearable 
                label="Select Financial Year">
              </v-select> -->

              <v-text-field
                v-if="rePassword"
                prepend-icon="location_city"  
                type="number"
                @change="setLocationBasedOnZipCode()" 
                ref="zipCode" 
                v-model="zipCode" 
                label="ZipCode">
              </v-text-field>

              <v-text-field
                v-if="zipCode"
                prepend-icon="dialpad"
                type="number"
                ref="mobile"
                v-model="mobile.value"
                :rules="mobile.rules"
                label="Mobile"
              ></v-text-field>
              
              <!-- <h3>
                <v-icon>location_city</v-icon>
                &nbsp;
                Select Your Organization Location
              </h3>
              <v-radio-group row required v-model="liveLocation" :rules="liveLocationRules">
                <v-radio
                  :key="`village`"
                  :label="`Village`"
                  :value="`village`"
                ></v-radio>
                <v-radio
                  :key="`block`"
                  :label="`Block`"
                  :value="`block`"
                ></v-radio>
                <v-radio
                  :key="`tehsil`"
                  :label="`Tehsil`"
                  :value="`tehsil`"
                ></v-radio>
                <v-radio
                  :key="`district`"
                  :label="`District`"
                  :value="`district`"
                ></v-radio>
              </v-radio-group> -->
              
                <v-select required v-if="zipCode" v-model="country.value" :items="gCountry" label="Country"></v-select>
                <v-select required v-if="country.value" v-model="state.value" :items="gState" item-text="state" label="State"></v-select>
                <v-select required v-if="state.value" v-model="district.value" :items="gDistrict" label="District"></v-select>
                <v-select required v-if="district.value" v-model="tehsil.value" :disabled="isDisabled('tehsil')" :items="gTehsil" label="Tehsil"></v-select>
                <v-select required v-if="tehsil.value" v-model="block.value" :disabled="isDisabled('block')" :items="gBlock" label="Block"></v-select>                    
                <v-select required v-if="block.value" v-model="village.value" :disabled="isDisabled('village')" :items="gVillage" label="Village"></v-select>              
             </v-flex>
             
              <!-- <v-flex xs6 sm1 md1>
              </v-flex>
              <v-flex xs6 sm2 md2>   
                <v-select required v-model="country.value" :items="gCountry" label="Country"></v-select>
                <v-select required v-model="district.value" :items="gDistrict" label="District"></v-select>
                <v-select required v-model="block.value" :disabled="isDisabled('block')" :items="gBlock" label="Block"></v-select>                    
              </v-flex>
              <v-flex xs6 sm1 md1>
              </v-flex>
              <v-flex xs6 sm2 md2>   
                <v-select required v-model="state.value" :items="gState" item-text="state" label="State"></v-select>
                <v-select required v-model="tehsil.value" :disabled="isDisabled('tehsil')" :items="gTehsil" label="Tehsil"></v-select>
                <v-select required v-model="village.value" :disabled="isDisabled('village')" :items="gVillage" label="Village"></v-select>                    
              </v-flex> -->
               <v-flex xs12  v-if="rePassword">   
                 <v-radio-group v-model="planDetails">
                  <v-radio
                    v-for="pack in brandPackageTypes"
                    :key="pack"
                    :label="`${pack} PLAN`"
                    :value="pack"
                  ></v-radio>
                </v-radio-group>
              </v-flex>   
           </v-layout>
        </v-card-text>
        </v-form>
        <v-spacer></v-spacer>
        <!-- <v-card-actions>  
          <v-spacer></v-spacer>
          <v-btn round 
            large 
            primary-title 
            class="primary white--text" 
            :disabled="!isValid" 
            type="submit" @click="signUp">
            Sign Up <v-icon right dark>cloud_done</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions> -->
        <v-card-actions>
          <v-spacer></v-spacer>
            <h3> Already a Member </h3>
            &nbsp; &nbsp;
            <v-btn round large href="/login" class="blue-grey white--text" type="submit">
              Go To Login  
              <v-icon right dark>cloud_upload</v-icon>
            </v-btn>
          <v-spacer></v-spacer> 
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
             <v-btn  href="/privacy-policy"  text>
              Privacy Policy
            </v-btn>
            <v-spacer></v-spacer> 
        </v-card-actions>  
      </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  <v-snackbar :timeout="timeout" top v-model="snackbar">
    {{message}}
  </v-snackbar>
  </v-app>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import axios from 'axios';
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { cfirebase } from '../../services/firebase.js'

export default {
  data () {
    return {
      message: null,
      isValid: true,
      snackbar: false,
      timeout: 5000,
      brand: '',
      zipCode : null,
      nameRules: [
        v => !!v || 'Brand Name is required',
        v => (v && v.length <= 50) || 'Name must be less than 50 characters'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      password: '',
      rePassword: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be Greater or equal to than 8 characters'
      ],
      liveLocation:'',
      liveLocationRules:[
        v => !!v || 'Live Location is required',
      ],
      mobile: {
        value: "",
        rules: [
          v =>
            /^$/.test(v) ||
            /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) ||
            "Mobile number is wrong"
        ]
      },
      // financialYear: {
      //   value: ""
      // },
      // identityType: {
      //   value: ""
      // },
      casteType: {
        value: ""
      },
      village: {
        value: "",
        rules:[
          (v) => {
            if(this.liveLocation != 'village')
            return !!v || 'Village is required'
            else 
            return true;
          },
        ]
      },
      block: {
        value: ""
      },
      tehsil: {
        value: ""
      },
      district: {
        value: ""
      },
      state: {
        value: ""
      },
      country: {
        value: ""
      },
      select: null,
      items: [
        'TRAIL PERIOD',
        '700/MONTH',
        '1800/QUATERLY',
        '3000/MONTH',
        '5000/YEAR'
      ],
      planDetails : null
    }
  },
  computed:{
    ...mapGlobalGetters(["selectedBrand"]),
    ...mapGlobalGetters({
      gVillage: "village",
      gBlock: "block",
      gTehsil: "tehsil",
      gDistrict: "district",
      gState: "state",
      gCountry: "country",
      // gFinancialYear: "financialYear",
      // gIdentityType: "identityType",
      gCasteType: "casteType",
      brandPackageTypes:"brandPackageTypes"
    }),
  },
  watch:{
    liveLocation(val,newVal){
      switch(newVal) {
        case 'village' : {
          if(['block','tehsil','district',''].includes(this.liveLocation)) {
            this.village.value = '';
          } 
          break;
        }
        
        case 'block' : {
          if(['tehsil','district',''].includes(this.liveLocation)) {
            this.block.value = '';
          } 
          break;
        }

        case 'tehsil' : {
          if(['district',''].includes(this.liveLocation)) {
            this.tehsil.value = '';
          } 
          break;
        }
      }
    }
  },
  created () {
    this.$bindAsObject(
      'brands',
      this.$root.$firebaseRefs.brand
    )
    this.$bindAsObject(
      'operators',
      this.$root.$firebaseRefs.operator
    )
  },
  destroyed () {
    // this.$unbind('brands')
    // this.$unbind('operators')
  },
  methods: {
    setLocationBasedOnZipCode(){
      let reg = /^[1-9][0-9]{5}$/;
      console.log(this.zipCode)
      if(this.zipCode && reg.test(this.zipCode)) {
        axios
          .get('https://api.postalpincode.in/pincode/'+this.zipCode)
          .then(response => {
            let data = response.data[0].PostOffice[0];
            this.gCountry.push(data.Country);
            this.gState.push(data.State);
            this.gDistrict.push(data.District);
            this.gTehsil.push(data.Block);
            setTimeout(() => {
              this.country.value = data.Country;
              this.district.value = data.District;
              this.state.value = data.State;
              this.tehsil.value = data.Block;
            }, 100);
        })
      }
    },
    isDisabled(type) {
      switch(type) {
        case 'village' : {
          if(['block','tehsil','district',''].includes(this.liveLocation)) {
            return true;
          } 
          return false;
          break;
        }
        
        case 'block' : {
          if(['tehsil','district',''].includes(this.liveLocation)) {
            return true;
          } 
          return false;
          break;
        }

        case 'tehsil' : {
          if(['district',''].includes(this.liveLocation)) {
            return true;
          } 
          return false;
          break;
        }
      }
    },
    isVerified () {
      if (this.password !== this.rePassword) {
        this.message = 'Password didn\'t match'
        return false
      }
      if (!this.password || !this.brand || !this.email) {
        this.message = 'Wrong Input'
        return false
      }
      if (this.isBrandExist(this.brand)) {
        this.message = 'Brand name already taken'
        return false
      }
      return true
    },
    isBrandExist (brand) {
      let objects = Object.keys(this.brands).filter(key => this.brands[key] === brand)
      if (objects.length) {
        return true
      }
      return false
    },
    // signUp () {
    //   if (!this.isVerified()) {
    //     this.snackbar = true
    //     return
    //   }
    //   cfirebase.auth().createUserWithEmailAndPassword(this.email, this.password)
    //     .then(data => {
    //       console.log(data)
    //       this.message = 'SignUp Successful'
    //       this.snackbar = true

    //       let brandKey = this.addNewBrand(this.brand)
    //       this.addNewUser(data.user.uid, brandKey)
    //       this.addPlanDetails(brandKey)
    //       this.sendEmailVerification()
    //       this.$router.push('/login')
    //     })
    //     .catch(error => {
    //       this.message = error.message
    //       this.snackbar = true
    //       // Handle Errors here.
    //       var errorCode = error.code
    //       var errorMessage = error.message
    //       console.log(errorCode, errorMessage)
    //     })
    // },
    addNewBrand (brand) {
      let createdBrand = this.$root.$firebaseRefs.brand.push(brand)
      console.log('createdBrand', createdBrand)
      return createdBrand['key']
    },
    addNewUser (uid, brandKey) {
      this.$root.$firebaseRefs.operator.push({ uid, brand: brandKey, role: 'admin',
      superAdmin:true,
      email:this.email,
      notificationWSAPP : true,
      village:this.village.value, 
      block:this.block.value,
      tehsil:this.tehsil.value,
      district:this.district.value,
      state:this.state.value,
      country:this.country.value,
      casteType: this.casteType.value,
      zipCode: this.zipCode,
      mobile: this.mobile.value,
      })
    },
    addPlanDetails(brandKey) {
      let brandPermission = {
          active : true,
          plan: this.planDetails,
          permissions:[],
          brand : brandKey
        };
        this.$root.$firebaseRefs.brandPermission.push(brandPermission);
    },
    sendEmailVerification(){
      cfirebase.auth().currentUser.sendEmailVerification();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SignUp/index.vue